<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card">
                <app-empty-content [isVisible]="!hasCompositionData(data) && !loading"
                    title="Nenhum acionista encontrado"
                    description="Não foi encontrado nenhum acionista para esta empresa"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="row" *ngIf="hasCompositionData(data)">
                    <div class="col-12" style="overflow-x:auto;">
                        <div class="custom-table-container pt-3">
                            <table class="custom-table"
                                *ngIf="data.length >= 2">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Relacionamento PEP</th>
                                        <th>% Participação</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <ng-container
                                        *ngFor="let item of data; let i = index">
                                        <tr [(ngbCollapse)]="item.collapsed">
                                            <td>
                                                <div
                                                    class="d-flex align-items-center">
                                                    <app-spacer
                                                        [left]="getSpace(i)"></app-spacer>

                                                    <div *ngIf="item.shareholders && item.shareholders.length === 0"
                                                        style="width: 26px;">
                                                    </div>

                                                    <ng-container
                                                        *ngIf="item.shareholders && item.shareholders.length > 0">
                                                        <button
                                                            (click)="handleSetCollapsed(i, item.isOpen)">
                                                            <svg-icon
                                                                src="assets/images/icon-down.svg"></svg-icon>
                                                        </button>
                                                    </ng-container>

                                                    <app-spacer
                                                        [right]="16"></app-spacer>

                                                    <div>
                                                        <div>
                                                            {{item.full_name}}
                                                        </div>
                                                        <div
                                                            class="custom-table-sub-text">
                                                            {{formatDocument(item.document)}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <ng-container *ngIf="item.pep_relationship_name || item.pep_bond">
                                                    <div>
                                                        <div>
                                                            {{item.pep_relationship_name
                                                            ?? ''}}
                                                            <ng-container
                                                                *ngIf="item.pep_bond">
                                                                ({{item.pep_bond}})
                                                            </ng-container>
                                                        </div>
                                                        <div
                                                            class="custom-table-sub-text">
                                                            {{item.pep_relationship_document
                                                            ?
                                                            formatDocument(item.pep_relationship_document)
                                                            : ''}}
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="!item.pep_relationship_name && !item.pep_bond">
                                                    <div>-</div>
                                                </ng-container>
                                            </td>

                                            <td>
                                                <ng-container *ngIf="item.id === undefined">
                                                    total {{getShareholdersPercentage(item.id)}}%
                                                </ng-container>
                                                <ng-container *ngIf="item.id !== undefined">
                                                    {{item.percentage}}%
                                                    <ng-container
                                                        *ngIf="item.shareholders && item.shareholders.length > 0">
                                                        (total
                                                        {{getShareholdersPercentage(item.id)}}%)
                                                    </ng-container>
                                                </ng-container>
                                            </td>


                                        </tr>


                                    </ng-container>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>

            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('main')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!getLoadingForView('main')">
                <ng-container
                    *ngIf="approvalService.approvalData.mainVersion && approvalService.approvalData.mainRevision">
                    <ng-template #versionTemplate let-versionType="versionType">
                        <div class="dash-details-card">
                            <app-empty-content 
                                [isVisible]="!hasCompositionData(versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType))"
                                title="Nenhum acionista encontrado"
                                description="Não foi encontrado nenhum acionista para esta empresa"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <div class="row"
                                *ngIf="hasCompositionData(versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType))">
                                <div class="col-12" style="overflow-x:auto;">
                                    <div class="custom-table-container pt-3">
                                        <table class="custom-table"
                                            *ngIf="(versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType)).length >= 2">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Relacionamento PEP</th>
                                                    <th>% Participação</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <ng-container
                                                    *ngFor="let item of (versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType)); let i = index">
                                                    <tr [ngbCollapse]="getItemStatus(item, versionType) === 'removed' ? false : item.collapsed"
                                                        [class]="getItemRowClass(item, versionType)">
                                                        <td>
                                                            <div
                                                                class="d-flex align-items-center">
                                                                <app-spacer
                                                                    [left]="getSpace(i, versionType)"></app-spacer>

                                                                <div *ngIf="item.shareholders && item.shareholders.length === 0"
                                                                    style="width: 26px;">
                                                                </div>

                                                                <ng-container
                                                                    *ngIf="item.shareholders && item.shareholders.length > 0">
                                                                    <button
                                                                        (click)="handleSetCollapsed(i, item.isOpen, versionType)">
                                                                        <svg-icon
                                                                            src="assets/images/icon-down.svg"></svg-icon>
                                                                    </button>
                                                                </ng-container>

                                                                <app-spacer
                                                                    [right]="16"></app-spacer>

                                                                <div
                                                                    style="display: flex; gap: 6px;">
                                                                    <div
                                                                        style="flex-shrink: 0; display: flex; align-items: center;">
                                                                        <div [innerHTML]="versionType === 'comparing' && getItemIcon(item, versionType) ? getItemIcon(item, versionType) : ''"
                                                                            style="flex-shrink: 0;">
                                                                        </div>
                                                                        <div [innerHTML]="getFieldComparisonIcon(item, versionType, 'document')"
                                                                            style="flex-shrink: 0;">
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.full_name
                                                                                ||
                                                                                'Sem
                                                                                nome'}}
                                                                            </span>
                                                                        </div>
                                                                        <div
                                                                            class="custom-table-sub-text">
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.document
                                                                                ?
                                                                                formatDocument(item.document)
                                                                                :
                                                                                'Sem
                                                                                documento'}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <ng-container *ngIf="item.pep_relationship_name || item.pep_bond">
                                                                <div
                                                                    style="display: flex; gap: 6px;">
                                                                    <div
                                                                        style="flex-shrink: 0; display: flex; align-items: center;">
                                                                        <div [innerHTML]="getFieldComparisonIcon(item, versionType, 'pep_relationship_name')"
                                                                            style="flex-shrink: 0;">
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.pep_relationship_name
                                                                                ??
                                                                                ''}}
                                                                            </span>
                                                                            <ng-container
                                                                                *ngIf="item.pep_bond">
                                                                                <span
                                                                                    [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                    ({{item.pep_bond}})
                                                                                </span>
                                                                            </ng-container>
                                                                        </div>
                                                                        <div
                                                                            class="custom-table-sub-text">
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.pep_relationship_document
                                                                                ?
                                                                                formatDocument(item.pep_relationship_document)
                                                                                :
                                                                                ''}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                            <ng-container *ngIf="!item.pep_relationship_name && !item.pep_bond">
                                                                <div>-</div>
                                                            </ng-container>
                                                        </td>

                                                        <td>
                                                                <div
                                                                    style="display: flex; align-items: center; gap: 6px;">
                                                                    <div [innerHTML]="getFieldComparisonIcon(item, versionType, 'percentage')"
                                                                        style="flex-shrink: 0;">
                                                                    </div>
                                                                <ng-container *ngIf="item.id === undefined">
                                                                    <span
                                                                        [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                        total {{getShareholdersPercentage(item.id,
                                                                        versionType)}}%
                                                                    </span>
                                                                </ng-container>
                                                                <ng-container *ngIf="item.id !== undefined">
                                                                    <span
                                                                        [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                        {{item.percentage}}%
                                                                    </span>
                                                                    <ng-container
                                                                        *ngIf="item.shareholders && item.shareholders.length > 0">
                                                                        <span
                                                                            [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                            (total
                                                                            {{getShareholdersPercentage(item.id,
                                                                            versionType)}}%)
                                                                        </span>
                                                                    </ng-container>
                                                                </ng-container>
                                                            </div>
                                                        </td>


                                                    </tr>


                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </ng-template>
                    <ng-container
                        *ngTemplateOutlet="versionTemplate; context: { versionType: 'main' }"></ng-container>
                </ng-container>
                <ng-container
                    *ngIf="!approvalService.approvalData.mainVersion || !approvalService.approvalData.mainRevision">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('comparing')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!getLoadingForView('comparing')">
                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion && approvalService.approvalData.comparingRevision">
                    <ng-template #versionTemplateComparing
                        let-versionType="versionType">
                        <div class="dash-details-card">
                            <app-empty-content 
                                [isVisible]="!hasCompositionData(versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType))"
                                title="Nenhum acionista encontrado"
                                description="Não foi encontrado nenhum acionista para esta empresa"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <div class="row"
                                *ngIf="hasCompositionData(versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType))">
                                <div class="col-12" style="overflow-x:auto;">
                                    <div class="custom-table-container pt-3">
                                        <table class="custom-table"
                                            *ngIf="(versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType)).length >= 2">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Relacionamento PEP</th>
                                                    <th>% Participação</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <ng-container
                                                    *ngFor="let item of (versionType === 'comparing' ? getDataForComparison(versionType) : getDataForView(versionType)); let i = index">
                                                    <tr [ngbCollapse]="getItemStatus(item, versionType) === 'removed' ? false : item.collapsed"
                                                        [class]="getItemRowClass(item, versionType)">
                                                        <td>
                                                            <div
                                                                class="d-flex align-items-center">
                                                                <app-spacer
                                                                    [left]="getSpace(i, versionType)"></app-spacer>

                                                                <div *ngIf="item.shareholders && item.shareholders.length === 0"
                                                                    style="width: 26px;">
                                                                </div>

                                                                <ng-container
                                                                    *ngIf="item.shareholders && item.shareholders.length > 0">
                                                                    <button
                                                                        (click)="handleSetCollapsed(i, item.isOpen, versionType)">
                                                                        <svg-icon
                                                                            src="assets/images/icon-down.svg"></svg-icon>
                                                                    </button>
                                                                </ng-container>

                                                                <app-spacer
                                                                    [right]="16"></app-spacer>

                                                                <div
                                                                    style="display: flex; gap: 6px;">
                                                                    <div
                                                                        style="flex-shrink: 0; display: flex; align-items: center;">
                                                                        <div [innerHTML]="versionType === 'comparing' && getItemIcon(item, versionType) ? getItemIcon(item, versionType) : ''"
                                                                            style="flex-shrink: 0;">
                                                                        </div>
                                                                        <div [innerHTML]="getFieldComparisonIcon(item, versionType, 'document')"
                                                                            style="flex-shrink: 0;">
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.full_name
                                                                                ||
                                                                                'Sem
                                                                                nome'}}
                                                                            </span>
                                                                        </div>
                                                                        <div
                                                                            class="custom-table-sub-text">
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.document
                                                                                ?
                                                                                formatDocument(item.document)
                                                                                :
                                                                                'Sem
                                                                                documento'}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <ng-container *ngIf="item.pep_relationship_name || item.pep_bond">
                                                                <div
                                                                    style="display: flex; gap: 6px;">
                                                                    <div
                                                                        style="flex-shrink: 0; display: flex; align-items: center;">
                                                                        <div [innerHTML]="getFieldComparisonIcon(item, versionType, 'pep_relationship_name')"
                                                                            style="flex-shrink: 0;">
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.pep_relationship_name
                                                                                ??
                                                                                ''}}
                                                                            </span>
                                                                            <ng-container
                                                                                *ngIf="item.pep_bond">
                                                                                <span
                                                                                    [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                    ({{item.pep_bond}})
                                                                                </span>
                                                                            </ng-container>
                                                                        </div>
                                                                        <div
                                                                            class="custom-table-sub-text">
                                                                            <span
                                                                                [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                                {{item.pep_relationship_document
                                                                                ?
                                                                                formatDocument(item.pep_relationship_document)
                                                                                :
                                                                                ''}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                            <ng-container *ngIf="!item.pep_relationship_name && !item.pep_bond">
                                                                <div>-</div>
                                                            </ng-container>
                                                        </td>

                                                        <td>
                                                            <div
                                                                style="display: flex; align-items: center; gap: 6px;">
                                                                <div [innerHTML]="getFieldComparisonIcon(item, versionType, 'percentage')"
                                                                    style="flex-shrink: 0;">
                                                                </div>
                                                                <ng-container *ngIf="item.id === undefined">
                                                                    <span
                                                                        [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                        total {{getShareholdersPercentage(item.id,
                                                                        versionType)}}%
                                                                    </span>
                                                                </ng-container>
                                                                <ng-container *ngIf="item.id !== undefined">
                                                                    <span
                                                                        [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                        {{item.percentage}}%
                                                                    </span>
                                                                    <ng-container
                                                                        *ngIf="item.shareholders && item.shareholders.length > 0">
                                                                        <span
                                                                            [style.text-decoration]="getItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                                            (total
                                                                            {{getShareholdersPercentage(item.id,
                                                                            versionType)}}%)
                                                                        </span>
                                                                    </ng-container>
                                                                </ng-container>
                                                            </div>
                                                        </td>


                                                    </tr>


                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </ng-template>
                    <ng-container
                        *ngTemplateOutlet="versionTemplateComparing; context: { versionType: 'comparing' }"></ng-container>
                </ng-container>
                <ng-container
                    *ngIf="!approvalService.approvalData.comparingVersion || !approvalService.approvalData.comparingRevision">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>

<app-side-modal [active]="compositionDetails"
    [title]="compositionDetails ? selectedPartner.full_name : '--'"
    (onClose)="closeModal()" paddingBottom="30">
    <div class="container" *ngIf="selectedPartner">
        <div class="row">
            <div class="col-12 col-md-6 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    {{selectedPartner.document &&
                    selectedPartner.document.length > 14 ? 'CNPJ' : 'CPF'}}
                </span>

                <span class="dash-details-card-item-title">
                    {{selectedPartner ? formatDocument(selectedPartner.document)
                    : '--'}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-md-6 d-flex flex-column"
                *ngIf="selectedPartner.pep">
                <span class="dash-details-card-item-badged-list">
                    Declaro PEP
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    participação
                </span>

                <span class="dash-details-card-item-title">
                    {{selectedPartner ? selectedPartner.percentage : '--'}}%
                </span>
                <app-spacer [bottom]="32"></app-spacer>
            </div>
        </div>

        <ng-container *ngIf="selectedPartner.pep_relationship">
            <app-label
                label="Possuo relacionamento com pessoa politicamente exposta">
            </app-label>

            <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Nome
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedPartner.pep_relationship_name}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Documento
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedPartner.pep_relationship_document ?
                        formatDocument(selectedPartner.pep_relationship_document)
                        : '--'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Vínculo
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedPartner.pep_bond}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>
            </div>
        </ng-container>

        <ng-container
            *ngIf="selectedPartner.files && selectedPartner.files.length > 0 ">
            <div class="row">
                <div class="col-12">
                    <h3>Anexos</h3>
                </div>
                <!-- <div class="col-12">
                    <app-attachment-button [files]="selectedPartner.files"
                        [full]="true"
                        (onSelect)="handleSelect($event)"></app-attachment-button>
                </div> -->
            </div>

            <app-spacer [bottom]="32"></app-spacer>
        </ng-container>
    </div>
</app-side-modal>

<app-modal #modalRoot class="modal-demo">
    <ng-container class="app-modal-header">
        <ng-container *ngIf="file">
            <svg-icon src="assets/images/icon_drag_indicator.svg"></svg-icon>
            <div>{{file.type.name}}</div>
            <div></div>
        </ng-container>
    </ng-container>
    <ng-container class="app-modal-body">
        <ng-container *ngIf="file">
            <img [src]="url" *ngIf="!isPDF && !isXLS" style="width:100%">
            <iframe [src]="url" *ngIf="isPDF || isXLS" frameborder="0"
                height="100%" width="100%">
            </iframe>
        </ng-container>
    </ng-container>
</app-modal>